// extracted by mini-css-extract-plugin
export default {"productGallery":"bO-z","inQuickShop":"cO-z"};